export default __webpack_public_path__ + "static/media/Inter-UI-LightItalic-BETA.7f7480c0.woff2";